import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { WorkedInactiveEmployeeReport } from './Pages';

export const WorkedInactiveEmployeeReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={WorkedInactiveEmployeeReport} />
    </Fragment>
)